module.exports = "/images/vendor/flag-icon-css/flags/4x3/co.svg?3b252a1a91262604a52801ec3dda088d";